<template>
  <div>
    <div class="row col-12 mt-3" v-loading="loadingCultures">
      <div class="card-deck col-12 ml-1" style="min-width: 38vw">
        <div class="card text-white mb-3">
          <div class="card-header row d-flex justify-content-between">
            <h5 class="card-title text-uppercase text-white mb-0 h3">Limite Sugerido em Moeda:</h5>
            <h5 class="card-title text-uppercase text-white mb-0 h3 float-right">R$ {{ this.totalLimitValue }}</h5>
          </div>
          <div class="card-body bg-white row">
            <div class="col-12 mb-4" v-for="culture in cultures" :key="culture.id">
              <div class="row d-flex justify-content-between" style="max-height: 2.4rem">
                <p class="text-dark"><strong>{{ culture.culture.culture_name }}</strong></p>
                <hr>
                <p class="text-dark"><strong>R$ {{ (culture.limit || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong> <span class="text-muted">{{ culture.percent }}</span></p>
              </div>
              <hr class="row mt-0">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'limits',
  props: {
    client_id: {
      type: Number
    }
  },
  data () {
    return {
      cultures: [],
      loadingCultures: false
    }
  },
  mounted () {
    this.getLimits()
  },
  methods: {
    async getLimits () {
      this.loadingCultures = true
      const data = {
        client_id: this.client_id
      }
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_cultures", { params: data} )
      this.cultures = response.data
      this.loadingCultures = false
    }
  },
  computed: {
    totalLimitValue () {
      let totalValue = 0
      this.cultures.length > 0 ? this.cultures.map(culture => {
        totalValue += culture.limit
      }) : []

      return totalValue
    }
  }
}
</script>

<style scoped>
.card-header {
    padding: 1.25rem 1.5rem;
    margin-bottom: 0;
    background-color: #2dce89;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.card {
  box-shadow: 0 0 2rem 0 rgb(136 152 170 / 25%);
}
</style>